import { Roles } from "../../../constants/roles";
import { NavbarSettingsForm } from "./navbar-settings-form";

export class NavbarSettingsHandler {
    private readonly form: NavbarSettingsForm;

    public constructor(form: NavbarSettingsForm) {
        this.form = form;
    }

    public bootstrap(): void {
        this.form.setOpen(false);
    }

    public handleOverlayClick(): void {
        this.form.setOpen(false);
    }

    public handleToggleClick(event: Event): void {
        event.preventDefault();
        this.form.setOpen(!this.form.isOpen());
    }

    public handleEscapeKey(event: KeyboardEvent): void {
        if (event.key !== "Escape") return;
        if (!this.form.isOpen()) return;
        this.form.setOpen(false);
    }

    public handleDocumentClick(event: Event): void {
        if (!this.form.isOpen()) return;

        const target = event.target;
        if (!(target instanceof Element)) return;

        const root = this.form.getRoot();
        if (root.contains(target)) return;

        this.form.setOpen(false);
    }

    public handlePopoverClick(event: Event): void {
        const connectButton = this.form.getConnectButton(event.target);
        if (!(connectButton instanceof HTMLButtonElement)) return;

        event.preventDefault();

        const connectUrl = connectButton.dataset.connectUrl?.trim() ?? "";
        if (connectUrl === "") return;

        window.open(connectUrl, "tiktok-oauth-connect", "popup=yes,width=720,height=860,resizable=yes,scrollbars=yes");

        this.form.setOpen(false);
    }

    public handleSettingsChanged(event: Event): void {
        if (!this.form.isOpen()) return;

        const target = event.target;
        if (!(target instanceof Element)) return;

        const isLanguageSelect =
            target instanceof HTMLInputElement &&
            target.type === "radio" &&
            target.matches(`[data-role="${Roles.LANGUAGE_SELECT}"]`);

        const isImageZoomToggle = target.matches(`[data-role="${Roles.PRODUCT_LIST_IMAGE_ZOOM_TOGGLE}"]`);

        if (!isLanguageSelect && !isImageZoomToggle) return;

        this.form.setOpen(false);
    }
}
